import customers from '@/store/modules/customers/customers'
import groups from '@/store/modules/customers/groups'

const modules = {
  customers,
  groups
}

export default {
  namespaced: true,
  modules
}
